<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h5>Активация смены</h5>
      </div>
      <div class="card-body">
        <div class="flex flex_gap">
          <div class="form-group">
            <label for="">Период</label>
            <div>
              <DateRangePicker
                ref="range"
              />
            </div>
          </div>
          <div class="form-group flex-grow-1">
            <label for="">Пользователи</label>
            <CustomMultiSelect ref="selectedUsers" :records="usersForSelect ?? users"/>
          </div>
          <div class="align-self-end">
            <LoadingButton
              title="Показать"
              :loading="loading"
              :color="$constants.LOADING_COLOR"
              :onClick="() => getRecords()"
              className="btn btn-outline-info"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="card table_block" v-if="loading || records">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <div class="table_div_block">
          <table class="table table-sm table-hover mt-1">
            <thead>
            <tr>
              <th class="def_width"></th>
              <!--            <th v-for="u in selectedUsers" v-if="hasRecords(u.id)" class="text-wrap">{{ u.id }} {{ u.name }}</th>-->
              <th v-for="date in dateRange" class="text-wrap">{{ date }}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="u in selectedUsers" v-if="hasRecords(u.id)">
              <td class="fixed-side">{{ u.id }} {{ u.name }}</td>
              <td v-for="date in dateRange">
                <p v-for="s in records[date][u.id]">
                  {{ shifts[s.work_shift_id]?.title }}
                  <span
                    :class="{'badge': true, 'badge-success': !s.is_active}">{{ printDate(s.created_at, 'HH:mm') }}
                </span>
                </p>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import CustomMultiSelect from "@/components/selects/CustomMultiSelect.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import DateRangePicker from "@/components/dateSelect/DateRangePicker.vue";
import moment from "moment";

export default {
  components: {DateRangePicker, LoadingButton, CustomMultiSelect},
  props: ['usersForSelect'],
  data() {
    return {
      loading: false,
      users: [],
      records: null,
      shifts: {},
      dateRange: [],
      selectedUsers: [],
    }
  },
  created() {
    if (!this.usersForSelect) {
      this.getUsers();
    } else {
      this.users = [...this.usersForSelect];
    }
  },
  methods: {
    hasRecords(id) {
      return Object.values(this.records ?? {}).find((r) => r[id]);
    },
    printDiff(record) {
      const start = moment(record.date_start);
      const end = moment(record.date_end);
      const duration = moment.duration(end.diff(start));
      return Math.round(duration.asMinutes());
    },
    async getRecords() {
      this.loading = true;
      const range = this.$refs.range.dateRange;
      const selected = [...this.$refs.selectedUsers.selectedRecords];
      this.selectedUsers = (selected.length ? selected : [...(this.usersForSelect ?? this.users)]);
      const {data} = await api.post('/analytics/managers/activities/shiftActivation', {
        dateRange: range,
        ids: this.selectedUsers.map((u) => u.id)
      })
      if (data.success) {
        this.dateRange = [];
        this.shifts = data.shifts.reduce((acc, s) => {
          acc[s.id] = s;
          return acc;
        }, {})
        this.records = data.records.reduce((acc, r) => {
          const date = moment(r.created_at).format('DD.MM.YYYY');
          if (!this.dateRange.includes(date)) this.dateRange.push(date);
          if (!acc[date]) acc[date] = {};
          if (!acc[date][r.user_id]) acc[date][r.user_id] = [];
          acc[date][r.user_id].push({...r});
          return acc;
        }, {});
      }
      this.loading = false;
    },
    async getUsers() {
      const {data} = await api.post('/new/users/list', {
        roles: ['manager', 'managerAssist']
      });
      if (data.success) {
        this.users = data.records.map((u) => {
          return {...u, selectTitle: '(' + u.id + ') ' + u.name}
        });
      }
    }
  }
}

</script>

<style scoped>
.table_div_block table {
  table-layout: fixed;
  width: 100%;
}

.table_block .card-body {
  position: relative;
  overflow: hidden;
}

.table_div_block {
  overflow-x: scroll;
  overflow-y: visible;
}

.table_div_block tr {
  //position: relative;
}

.table_div_block td,
.table_div_block th {
  width: 100px;
}

.table_div_block th.def_width {
  width: 170px;
}

.table_div_block td.fixed-side {
  position: absolute;
  width: 170px;
  height: 100%;
  background-color: white;
  padding: 3px;
}

.flex_gap {
  gap: 10px;
}

.form-group {
  margin-bottom: 0;
}

span {
  font-size: 14px;
}
</style>
